var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('overview-table',{attrs:{"projects":_vm.getProjects,"isDisabled":_vm.getIsDisabled},on:{"deleteItem":_vm.deleteItem,"createItem":_vm.createItem,"renameItem":_vm.renameItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }